/* global angular */
( function () {
	/* eslint no-undef:0, no-use-before-define:0 */
	'use strict';

	/* eslint-disable max-params */
	function EditObservation ( $scope, $location, logger, apiService, moment, $modal, $routeParams, Session, TITLE, _, $window, $timeout, $rootScope, observationService, TOOLTIP_MESSAGES, INFO, reportService, evidenceService, persistence, ppdFactory ) {
		/* eslint-enable max-params */
		var self        = this;
		var prevObsData = null;

		self.title = TITLE.obsEdit;

		self.filterBy       = 'Everything';
		self.defaultType    = 'Select a Type';
		self.collapseHeader = true;
		self.tooltip        = TOOLTIP_MESSAGES;

		self.templateFilter     = [];
		self.dateData           = {};
		self.endDate            = {};
		self.id                 = $routeParams.id;
		self.autoSaving         = false;
		self.activeTimerCount   = 0;
		self.activeCounterCount = 0;
		self.scoreLoading       = false;
		self.printLoading       = false;
		self.inReview           = false;
		self.autoSaveCount      = 0;

		// where upload process invoked
		$rootScope.uploadScope = $scope;

		self.dateOptions = {
			'formatYear'  : 'yyyy',
			'startingDay' : 0,
			'showWeeks'   : false
		};

		self.format = 'MM/dd/yy';

		self.droppedEvidence = [];

		function datePickerEvents ( startDate, endDate ) {
			self.dateData.dt = moment( startDate ).format();

			if ( endDate ) {
				self.endDate.edt = moment( endDate ).format();
			}

			function startOpen ( $event ) {
				$event.preventDefault();

				$timeout( function () {
					self.startOpened = true;
					self.endOpened   = false;
				}, 0 );
			}

			function endOpen ( $event ) {
				$event.preventDefault();

				$timeout( function () {
					self.endOpened   = true;
					self.startOpened = false;
				}, 0 );
			}

			self.startOpen = startOpen;
			self.endOpen   = endOpen;
		}

		function timePickerEvents ( startDate, endDate ) {
			self.dateData.st = moment( startDate ).format();

			if ( endDate ) {
				self.endDate.et = moment( endDate ).format();
			}

			self.hstep = 1;
			self.mstep = 1;

			self.isMeridian = true;

			self.toggleMode = function () {
				self.isMeridian = !self.isMeridian;
			};
		}

		function finalizeDate ( setTo, getFrom ) {
			return moment( setTo ).hours( moment( getFrom ).hours() ).minutes( moment( getFrom ).minutes() ).format();
		}

		$scope.$watch( angular.bind( self, function () {
			return self.endDate.et + self.endDate.edt;
		} ), function ( val ) {
			if ( val && !self.obsData.endDate ) {
				self.obsData.endDate = finalizeDate( self.endDate.edt, self.endDate.et );

				// for endtime: update time/date vice versa
				timePickerEvents( self.obsData.startDate, self.obsData.endDate );
				datePickerEvents( self.obsData.startDate, self.obsData.endDate );
			}
		}, true );

		function validateTemplate () {
			self.obsData.template.creator = _.pick( self.obsData.template.creator, 'id' );

			self.obsData.template.groups.map( function ( group ) {
				delete group.index;
			} );
		}

		function setComputedScore ( printCallback ) {
			var params =  {
				'observationId' : $routeParams.id,
				'userId'        : Session.getCredentials().userId,
				'observation'   : 'observations'
			};

			apiService.observation
			.get( params, function ( data ) {
				self.obsData.score = data.score;

				// set section score
				_.each( data.template.groups, function ( group, index ) {
					self.obsData.template.groups[ index ].score = group.score;
				} );

				self.scoreLoading = false;

				if ( printCallback ) {
					printCallback();
				}
			} );
		}

		function isValidScore ( score ) {
			return angular.isNumber( score );
		}

		function isInvalidDateTimeRange () {
			var isInvalidTimeRange = moment( self.dateData.dt ).isSame( self.endDate.edt, 'day' ) && moment( self.dateData.st ).isAfter( self.endDate.et, 'minutes' );
			var isInvalidDateRange = moment( self.dateData.dt ).isAfter( self.endDate.edt, 'day' );

			return isInvalidTimeRange || isInvalidDateRange;
		}

		function updateObservation ( isClose, printCallback, quickAccess ) {
			self.autoSaveStatus = null;

			if ( Object.keys( self.endDate ).length && isInvalidDateTimeRange() ) {
				self.autoSaving     = false;
				self.scoreLoading   = false;
				self.updateLoading  = false;
				self.autoSaveStatus = {
					'status'     : 'failed',
					'statusText' : 'Failed saving.'
				};

				return logger.notifyError( 'Invalid end date or time range', 'Unable to submit' );
			}

			self.obsData.startDate = finalizeDate( self.dateData.dt, self.dateData.st );

			if ( self.endDate.et ) {
				self.obsData.endDate = finalizeDate( self.endDate.edt, self.endDate.et );
			}

			validateTemplate();

			var newObsData  = angular.toJson( self.obsData );

			if ( ( newObsData !== prevObsData ) || isClose || printCallback ) {
				self.scoreLoading = true;

				var prescribedResources = [];
				var template = angular.copy( self.obsData.template );

				if ( self.obsData.prescribedResources ) {
					prescribedResources = angular.copy( self.obsData.prescribedResources );
				}

				// quick fix for extra attributes passed to api
				if ( template.rubric ) {
					template.rubric.map( observationService.maskUtil().rubricMask );
				}

				template.groups.map( observationService.maskUtil().groupMask );
				prescribedResources = prescribedResources.map( observationService.maskUtil().prescribedResourcesMask );
				template.groups.map( observationService.maskUtil().openEndedMask );

				var params = {
					'id'                  : $routeParams.id,
					'name'                : self.obsData.name,
					'observee'            : _.pick( self.obsData.observee, 'id' ),
					'observer'            : _.pick( self.obsData.observer, 'id' ),
					'location'            : _.pick( self.obsData.location, 'observeeClientId' ),
					'inReview'            : Boolean( self.inReview ),
					'partialSubmission'   : true,
					'startDate'           : self.obsData.startDate,
					'endDate'             : self.obsData.endDate,
					'evidences'           : self.obsData.evidences,
					'masterEvidences'     : self.obsData.masterEvidences,
					'template'            : template,
					'type'                : self.obsData.type,
					'tags'                : self.templateFilter,
					'prescribedResources' : prescribedResources,

					'masterPrescribedResources' : self.obsData.masterPrescribedResources
				};

				if ( self.obsData.manualScore ) {
					params.manualScore = self.obsData.manualScore;
				}

				prevObsData = newObsData;

				$scope.vm.autoSaving = true;

				if ( isClose ) {
					self.updateLoading = true;
				}

				if ( isClose && !self.endDate.et ) {
					params = _.omit( params, 'endDate' );
				}

				if ( self.obsData.digitalSignature ) {
					params.digitalSignature = self.obsData.digitalSignature;
				}

				++self.autoSaveCount;

				apiService.observation
				.update( {
					'userId'      : Session.getCredentials().userId,
					'observation' : 'observation'
				}, observationService.normalize( params, self, isClose ),
				function () {
					self.autoSaving     = false;
					self.autoSaveStatus = {
						'status'     : 'success',
						'statusText' : 'Saved.'
					};

					if ( isClose ) {
						self.scoreLoading = false;

						if ( quickAccess.activeTimers && !quickAccess.submit ) {
							logger.notifySuccess( 'Running timers have been stopped and saved', 'Observation' );
						}

						if ( quickAccess.submit ) {
							return self.submitObs( quickAccess.activeTimers, true );
						}

						self.updateLoading = false;
						var url = '/observations';

						$location.path( url );
					} else {
						self.setComputedScore( printCallback );
					}

					if ( quickAccess && quickAccess.evidenceData ) {
						$scope.$broadcast( 'enable:timer:counter:buttons', quickAccess );
						// close add timer/counter modal
						$scope.$emit( 'close:add:modal' );
					}

					if ( quickAccess && quickAccess.type === 7 && quickAccess.fromAdd && !quickAccess.fromAdd.startTimer ) {
						$scope.$broadcast( 'change:label:', quickAccess.evidenceData.id, true );
					}

					persistence.observationsActiveList = 0;

					if ( self.inReview ) {
						persistence.observationsActiveList = 1;
					}

					// this is to make sure that the displayed score is updated
					$timeout( function () {
						self.scoreLoading = false;
					}, 1000 );
				},
				function () {
					self.autoSaving     = false;
					self.scoreLoading   = false;
					self.updateLoading  = false;
					self.autoSaveStatus = {
						'status'     : 'failed',
						'statusText' : 'Failed saving.'
					};

					// remove signature if saving fails
					if ( !self.inReview ) {
						delete self.obsData.digitalSignature;
					}
				} ).$promise.finally( function () {
					self.printLoading = false;
					self.scoreLoading = false;
				} );
			}
		}

		function confirmEvidencesModal ( unAttachedEvidences, submit ) {
			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/components/evidences/confirmation/evidences-confirmation-modal.html',
				'controller'   : 'EvidencesConfirmationController',
				'controllerAs' : 'vm',
				'size'         : 'md',
				'resolve'      : {
					'unAttachedEvidences' : function () {
						return unAttachedEvidences;
					}
				}
			} );

			modalInstance.result.then( function () {
				self.obsData.evidences = ( self.obsData.evidences || [] ).concat( unAttachedEvidences );
				$scope.$broadcast( 'check:active:timers', submit );
			} );
		}

		function submitObservation ( activeTimers, isFinal ) {
			var startDate = finalizeDate( self.dateData.dt, self.dateData.st );
			var endDate   = '';

			if ( self.endDate.et ) {
				endDate = finalizeDate( self.endDate.edt, self.endDate.et );
			}

			validateTemplate();

			var template            = angular.copy( self.obsData.template );
			var prescribedResources = [ ];

			if ( self.obsData.prescribedResources ) {
				prescribedResources = angular.copy( self.obsData.prescribedResources );
			}

			// quick fix for extra attributes passed to api
			template.groups.map( observationService.maskUtil().groupMask );
			template.groups.map( observationService.maskUtil().openEndedMask );
			( template.rubric || [] ).map( observationService.maskUtil().rubricMask );

			prescribedResources = prescribedResources.map( observationService.maskUtil().prescribedResourcesMask );

			var params = {
				'id'                : self.id,
				'name'              : self.obsData.name,
				'observee'          : _.pick( self.obsData.observee, 'id' ),
				'observer'          : _.pick( self.obsData.observer, 'id' ),
				'location'          : _.pick( self.obsData.location, 'observeeClientId' ),
				'partialSubmission' : false,
				'startDate'         : startDate,
				'endDate'           : endDate,
				'submitDate'        : moment().format(),
				'evidences'         : self.obsData.evidences,
				'masterEvidences'   : self.obsData.masterEvidences,
				'template'          : template,
				'inReview'          : false,

				'masterPrescribedResources' : self.obsData.masterPrescribedResources,

				// if not set, leave it blank
				'type'                : self.obsData.type,
				'tags'                : self.templateFilter,
				'prescribedResources' : prescribedResources
			};

			if ( self.obsData.manualScore ) {
				params.manualScore = self.obsData.manualScore;
			}

			if ( !self.endDate.et ) {
				params = _.omit( params, 'endDate' );
			}

			if ( self.obsData.digitalSignature ) {
				params.digitalSignature = self.obsData.digitalSignature;
			}

			self.submitLoading = true;

			apiService.observation
			.update( {
				'userId'      : Session.getCredentials().userId,
				'observation' : 'observation'
			}, observationService.normalize( params, self, isFinal ) )
			.$promise.then( function () {
				self.submitLoading = false;

				if ( activeTimers ) {
					logger.notifySuccess( 'Running timers have been stopped and saved', 'Observation' );
				}

				persistence.observationsActiveList = 2;

				var url = '/observations';

				$location.path( url );
			}, function () {
				self.submitLoading = false;
				logger.error( 'Unable to submit.', ''  );
			} );
		}

		function printThis () {
			$timeout( function () {
				$window.print();
			}, 500 );
			self.printLoading = false;
		}

		function updatePrintOptions () {
			self.printLoading = true;
			self.updateObs( false, printThis );
		}

		function setEndDate () {
			return function ( model ) {
				model.endDate.edt = finalizeDate( new Date(), new Date() );
				model.endDate.et = finalizeDate( new Date(), new Date() );

				model.obsData.endDate = finalizeDate( new Date(), new Date() );
			};
		}

		function checkCompletion ( indicator ) {
			var isValid = false;

			switch ( indicator.type ) {
				case 1:
					isValid = ( indicator.answerText && indicator.answerText.length > 0 || indicator.score !== undefined );
					break;

				case 2:
				case 3:
				case 4:
					if ( indicator.answerOptions ) {
						indicator.answerOptions.forEach( function ( option ) {
							if ( option.selected === true ) {
								isValid = true;
							}
						} );
					}
					break;
			}

			return isValid;
		}

		function checkValidIndicator ( observation ) {
			var totalIndicators = [];
			var validIndicators = [];

			observation.template.groups.forEach( function ( group ) {
				( group.indicators || [] ).forEach( function ( indicator ) {
					totalIndicators.push( indicator.id );
					if ( indicator.isRequired && indicator.notApplicable !== true ) {
						if ( checkCompletion( indicator ) ) {
							validIndicators.push( indicator.id );
						}
					} else {
						validIndicators.push( indicator.id );
					}
				} );
			} );

			return validIndicators.length === totalIndicators.length;
		}

		function checkValidObs ( obs ) {
			var isInvalidEndDateForComplete = isInvalidDateTimeRange();
			var hasRequired                 = !checkValidIndicator( obs );

			var errorHandlers = [ {
				'conditon' : isInvalidEndDateForComplete,
				'handler'  : logger.notifyError
			}, {
				'conditon' : hasRequired,
				'handler'  : requiredIndicatorsModal
			} ];

			return !errorHandlers.filter( function ( handler ) {
				return handler.conditon;
			} ).map( function ( err ) {
				err.handler( 'Invalid end date or time range', 'Unable to submit' );
				return err;
			} ).length;
		}

		function requiredIndicatorsModal () {
			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/observations/observation-edit/required-indicators-modal.html',
				'controller'   : 'RequiredIndicatorsModalController',
				'controllerAs' : 'vm'
			} );

			return modalInstance.result;
		}

		function submitSaveClose ( submit ) {
			if ( submit ) {
				var isValid = checkValidIndicator( self.obsData );

				if ( !isValid ) {
					requiredIndicatorsModal();
					return;
				}
			}
			[ submit && !Object.keys( self.endDate ).length ].filter( Boolean ).reduce( setEndDate, angular.noop )( self );

			var isInvalidEndDateForComplete = ( isInvalidDateTimeRange() || !Object.keys( self.endDate ).length || !self.endDate.et ) && submit;
			var isInvalidEndDateForInProg   = Object.keys( self.endDate ).length && isInvalidDateTimeRange() && !submit;

			if ( isInvalidEndDateForComplete || isInvalidEndDateForInProg ) {
				return logger.notifyError( 'Invalid end date or time range', 'Unable to submit' );
			}

			var hasUnAttachedEvidences = observationService.hasUnAttachedEvidences( angular.copy( self.obsData ) );

			if ( hasUnAttachedEvidences.length && submit ) {
				self.submitLoading = false;
				confirmEvidencesModal( hasUnAttachedEvidences, submit );
			} else {
				self.updateLoading = true;
				$scope.$broadcast( 'check:active:timers', submit );
			}
		}

		function confirmInReview () {
			$modal.open( {
				'templateUrl'  : '/templates/observations/observations-list/obs-manage-priv-modal.html',
				'controller'   : 'ObsManagePrivModalController',
				'controllerAs' : 'vm',
				'resolve'      : {
					'confirmInReviewObj' : function () {
						return {
							'observationId' : self.obsData.id,
							'passedObs'     : self.obsData,
							'autoSaveCount' : self.autoSaveCount,
							'checkValid'    : checkValidObs,
							'location'      : 'obs-edit'
						};
					}
				}
			} ).result.then( submitSaveClose );
		}

		function confirmObs () {
			$modal.open( {
				'templateUrl'  : '/templates/observations/confirm-modal/obs-confirm-modal.html',
				'controller'   : 'obsConfirmCompleteModal',
				'controllerAs' : 'vm',
				'windowClass'  : '',
				'resolve'      : {
					'obs' : function () {
						return self.obsData;
					},

					'submitFn' : function () {
						return submitSaveClose;
					},

					'submitStatus' : function () {
						return 'complete';
					},

					'parentCtrl' : function () {
						return self;
					},

					'checkValid' : function () {
						return { 'checker' : checkValidObs };
					}
				}
			} );
		}

		function confirmModal ( confirmMsgTpl ) {
			var confirmMessages = {
				'inReview' : confirmInReview,
				'complete' : confirmObs
			};

			confirmMessages[ confirmMsgTpl ]();
		}

		var nullTitle = {
			'title' : ''
		};

		function getProficiency ( group ) {
			var proficiencyTitle = null;

			group.rubric.forEach( function ( proficiency ) {
				if ( group.score > proficiency.minRange && group.score <= proficiency.maxRange ) {
					proficiencyTitle = proficiency.title;
				}
			} );
			return proficiencyTitle || ( group.rubric[ group.rubric.length - 1 ] || nullTitle ).title;
		}

		self.toggleModal = function () {
			$modal.open( {
				'templateUrl'  : '/templates/components/evidences/script/scripting-mode.html',
				'controller'   : 'ScriptingModeController',
				'controllerAs' : 'vm',
				'windowClass'  : 'scripting-modal fade in',
				'resolve'      : {
					'evidences' : function () {
						return self.obsData.evidences;
					},

					'updateObs' : function () {
						return updateObservation;
					},

					'observation' : function () {
						return self.obsData;
					}
				}
			} );
		};

		function getGroups ( groupsData ) {
			$rootScope.$broadcast( 'obs:get:groups', groupsData );
		}

		function toggleTimerNotification ( id ) {
			var index = self.timersActive.indexOf( id );

			if ( index >= 0 ) {
				self.timersActive.splice( index, 1 );

				if ( self.timersActive.length === 0 ) {
					self.runningTimer = false;
				}
			}
		}

		function resolveNA () {
			var index = 0;

			self.obsData.template.groups.map( function ( group ) {
				group.index = index++;

				_.map( group.indicators, function ( indicator ) {
					if ( indicator.notApplicable === undefined && indicator.score !== undefined ) {
						indicator.notApplicable = false;
					}
				} );
			} );
		}

		function activate () {
			var params =  {
				'observationId' : $routeParams.id,
				'userId'        : Session.getCredentials().userId,
				'observation'   : 'observations'
			};

			self.loadingObs = true;

			apiService.observation
			.get( params, function ( rawData ) {
				if ( !rawData.partialSubmission || ( rawData.partialSubmission && rawData.inReview && Session.getCredentials().userId !== rawData.observer.id ) ) {
					$location.path( '/observations/' + $routeParams.id + '/'  );
				}

				self.obsData = observationService.denormalize( rawData );

				self.dateData     = {};
				self.inReview     = Boolean( self.obsData.inReview );
				self.poolNav      = 'evidences';
				self.observeeName = self.obsData.observee.lastName + ', ' +  self.obsData.observee.firstName;
				self.observerName = self.obsData.observer.lastName + ', ' +  self.obsData.observer.firstName;

				getGroups( self.obsData.template.groups );
				datePickerEvents( self.obsData.startDate, self.obsData.endDate );
				timePickerEvents( self.obsData.startDate, self.obsData.endDate );

				resolveNA();

				self.obsData.startDate = finalizeDate( self.dateData.dt, self.dateData.st );
				self.isScore           = Boolean( self.obsData.hasOwnProperty( 'score' ) );
				self.loadingObs        = false;

				prevObsData = angular.toJson( self.obsData );

				ppdFactory.setMasterSource( self.obsData );
			}, function () {
				$location.path( '/observations' );
				logger.notifyError( '/observations/' + $routeParams.id + '/edit' );
				logger.error( 'Unable to fetch.', '' );
			} );

			$scope.$on( 'updateObs', function ( ev, quickAccess ) {
				self.updateObs( false, null, quickAccess );
			} );

			$scope.$on( 'edit:delete:evidences', function ( event, evidence, action ) {
				evidenceService.editDeleteEvidence( evidence, action, self.obsData );
			} );

			$scope.$on( 'start:time:', function ( ev, id ) {
				var index = self.timersActive.indexOf( id );

				if ( index === -1 ) {
					self.timersActive.push( id );
				}
				self.runningTimer = true;
			} );

			angular.forEach( [ 'stop:time:', 'delete:timer' ], function ( value ) {
				$scope.$on( value, function ( ev, id ) {
					self.toggleTimerNotification( id );
				} );
			} );

			$scope.$on( 'file:uploading', function ( event, progress ) {
				self.uploadProgress = progress;
			} );

			logger.info( 'Activated Edit Observation View' );
		}

		activate();

		self.submitObs               = submitObservation;
		self.getProficiency          = getProficiency;
		self.updateObs               = updateObservation;
		self.updatePrintOptions      = updatePrintOptions;
		self.setComputedScore        = setComputedScore;
		self.submitSaveClose         = submitSaveClose;
		self.datePickerEvents        = datePickerEvents;
		self.timePickerEvents        = timePickerEvents;
		self.printThis               = printThis;
		self.timerMsg                = INFO.obsStartTimer;
		self.uploadProgressMsg       = INFO.obsUploadProgress;
		self.isValidScore            = isValidScore;
		self.toggleTimerNotification = toggleTimerNotification;
		self.timersActive            = [];
		self.hasPdfMake              = reportService.hasPdfMake;
		self.confirmModal            = confirmModal;
	}

	angular
		.module( 'app.observations' )
		.controller( 'EditObservation', EditObservation );

	EditObservation.$inject = [ '$scope', '$location', 'logger', 'apiService', 'moment', '$modal', '$routeParams', 'Session', 'TITLE', '_', '$window', '$timeout', '$rootScope', 'observationService', 'TOOLTIP_MESSAGES', 'INFO', 'reportService', 'evidenceService', 'persistence', 'ppdFactory' ];
} )();
